customElements.get('address-autocomplete-field') || customElements.define('address-autocomplete-field',
  class extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.initAutocomplete()
      if (this.querySelector('.address-autocomplete-field__submit-button')) {
        this.querySelector('.address-autocomplete-field__submit-button').addEventListener("click", () => this.handleButtonClick());
      }
      this.querySelector('input').addEventListener('focus', () => this.handleRemoveErrorMessage());
    }

    initAutocomplete() {
      let autocompleteInputs = document.querySelectorAll('#autocomplete');
      autocompleteInputs.forEach(input => {
        let autocomplete = new google.maps.places.Autocomplete(
          input,
          {
            types: ['street_address', 'premise'],
            componentRestrictions: { 'country': ['US'] },
            fields: ['geometry', 'formatted_address']
          }
        );
        autocomplete.addListener('place_changed', () => this.onPlaceChanged(autocomplete));
      })
    }

    showLoader() {
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      this.querySelector('button').classList.add('ls-button--text-hidden');
    }

    hideLoader() {
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      this.querySelector('button').classList.remove('ls-button--text-hidden');
    }

    onPlaceChanged = (autocomplete) => {
      var place = autocomplete.getPlace();
      if (!place.geometry) {
        //User did not select a prediction; reset the input field
        document.getElementById('autocomplete').placeholder = 'Enter your home address';
      } else {
        sessionStorage.setItem("ls-lat", place.geometry.location.lat());
        sessionStorage.setItem("ls-lng", place.geometry.location.lng());
        sessionStorage.setItem("ls-address", place.formatted_address);
        document.dispatchEvent(new CustomEvent('placeChanged'))
      }
    }

    handleRemoveErrorMessage() {
      this.querySelector("#address-autocomplete-field__error-message")?.remove();
    }

    handleErrorMessage = () => {
      if (this.querySelector('#address-autocomplete-field__error-message')) return;

      const errorMessageDiv = document.createElement("div")
      errorMessageDiv.setAttribute('id', 'address-autocomplete-field__error-message');
      const errorMessage = document.createTextNode("Please type your address in the field below and select an address from the dropdown. 👇");
      errorMessageDiv.appendChild(errorMessage);
      this.insertAdjacentElement('afterbegin', errorMessageDiv);
    }

    handleButtonClick() {
      this.showLoader()
      if (sessionStorage.getItem('ls-lat')) {
        window.location.href = "/pages/calculate-yard-size";
      } else {
        this.hideLoader()
        this.handleErrorMessage();
      }
    }
  }
)
